/**
 * Calculate the percentage of the screen for a given HTMLElement.
 * If the element is fully visible on the screen, it will return 100%
 *
 * @param {HTMLElement} element
 *   The element to calculate the size.
 *
 * @param {number} topMargin
 *   The top margin to account for the fixed header.
 */
export const getScreenPercentage = (element: HTMLElement, topMargin = 0): number => {
    const viewport = {
        top: window.scrollY + topMargin,
        bottom: window.scrollY + window.innerHeight,
    };

    const elementBoundingRect = element.getBoundingClientRect();
    const elementPos = {
        top: elementBoundingRect.y + viewport.top,
        bottom: elementBoundingRect.y + elementBoundingRect.height + viewport.top,
    };

    if (viewport.top > elementPos.bottom || viewport.bottom < elementPos.top) {
        return 0;
    }

    // Element is fully within viewport
    if (viewport.top < elementPos.top && viewport.bottom > elementPos.bottom) {
        return 100;
    }
    // Element is bigger than the viewport
    if (elementPos.top < viewport.top && elementPos.bottom > viewport.bottom) {
        return 100;
    }

    const elementHeight = elementBoundingRect.height;
    let elementHeightInView = elementHeight;

    if (elementPos.top < viewport.top) {
        elementHeightInView = elementHeight - (viewport.top - elementPos.top);
    }

    if (elementPos.bottom > viewport.bottom) {
        elementHeightInView = elementHeightInView - (elementPos.bottom - viewport.bottom);
    }
    const percentageInView = (elementHeightInView / (window.innerHeight - topMargin)) * 100;

    return Math.round(percentageInView);
};

export default getScreenPercentage;
